import { AnalyticPeriodsEnum } from '@workalizer/shared';
import { groupByPeriod } from '@workalizer/shared/utils';
import { formatISO, setMinutes, setSeconds } from 'date-fns';
export var analyticChatActivity = function (events, users, dateFrom, dateTo, groupBy, usersInOrgUnits) {
    if (usersInOrgUnits === void 0) { usersInOrgUnits = []; }
    var orgUnitByUserId = new Map(usersInOrgUnits.map(function (u) { return [u.userId, u.orgUnitId]; }));
    var mappedData = groupBy === AnalyticPeriodsEnum.HOUR
        ? events.map(function (event) { return ({
            items: [event],
            date: formatISO(setSeconds(setMinutes(new Date(event.date), 0), 0))
        }); })
        : events.map(function (event) { return ({
            items: [event],
            date: formatISO(event.date, { representation: 'date' })
        }); });
    var eventsGroupedByPeriod = groupByPeriod(mappedData, dateFrom, dateTo, groupBy);
    var response = eventsGroupedByPeriod.map(function (item) {
        var usersWithEvents = users.map(function (user) {
            var _a;
            var eventsCount = item.items
                .filter(function (event) { return event.userId === user.id; })
                .reduce(function (acc, event) { return acc + event._count.id; }, 0);
            var orgUnitId = (_a = orgUnitByUserId.get(user.id)) !== null && _a !== void 0 ? _a : null;
            return {
                userId: user.id,
                orgUnitId: orgUnitId,
                eventsCount: eventsCount
            };
        });
        return {
            date: item.date,
            users: usersWithEvents
        };
    });
    return response;
};
